exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.orange-btn[data-v-4e01f254] {\n  background: #ffa700 !important;\n  color: white !important;\n}\n", ""]);

// exports
